import React from 'react';
import { Dropdown, Tooltip } from 'antd';

import ButtonWithRole from '../../../../components/ButtonWithRole';
import RecacheIntervalCard from '../../../recache-interval-settings/recacheIntervalCard';
import { CONTENT_WRITE_REFUSED_ROLES } from '../../../auth/roleCapabilities';
import { Walkthrough } from '~features/FreeTrial';
import CacheFreshnessModal from './CacheFreshnessModal';

function CacheExpirationDropdownLegacy({
  onUpdateCacheFreshness,
  cacheSettingsToolTip,
}: {
  onUpdateCacheFreshness: (days: number) => void;
  cacheSettingsToolTip: string;
}) {
  const { updateAvailableTargets } = Walkthrough.useWalkthroughTargets();
  const [cacheFreshnessModalVisible, setCacheFreshnessModalVisible] = React.useState(false);
  const [confirmCacheFreshnessModal, setConfirmCacheFreshnessModal] = React.useState({
    visible: false,
    value: 0,
  });

  const handleRef = React.useCallback(
    (node: HTMLDivElement | null) => updateAvailableTargets('cache-settings', !!node),
    []
  );

  const onConfirmCacheFreshness = () => {
    onUpdateCacheFreshness(confirmCacheFreshnessModal.value);
    setConfirmCacheFreshnessModal({ visible: false, value: 0 });
    setCacheFreshnessModalVisible(false);
  };

  const onRecacheIntervalEvent = ({
    action,
    payload,
  }: {
    action: 'updateCacheFreshnessSlider' | 'closeCacheFreshnessCard';
    payload: { interval: number };
  }) => {
    if (action === 'closeCacheFreshnessCard') setCacheFreshnessModalVisible(false);
    if (action === 'updateCacheFreshnessSlider') {
      if (payload.interval < 1) {
        setConfirmCacheFreshnessModal({ visible: true, value: payload.interval });
      } else {
        onUpdateCacheFreshness(payload.interval);
      }
      setCacheFreshnessModalVisible(false);
    }
  };

  return (
    <>
      <CacheFreshnessModal
        open={confirmCacheFreshnessModal.visible}
        onOk={onConfirmCacheFreshness}
        onCancel={() => setConfirmCacheFreshnessModal({ visible: false, value: 0 })}
      />

      <Dropdown
        popupRender={() => (
          <div style={{ maxWidth: 500, background: '#ffffff' }}>
            <RecacheIntervalCard onEvent={onRecacheIntervalEvent} />
          </div>
        )}
        trigger={['click']}
        placement="bottomRight"
        onOpenChange={setCacheFreshnessModalVisible}
        open={cacheFreshnessModalVisible}
        destroyOnHidden
      >
        <Tooltip title={cacheSettingsToolTip}>
          <div ref={handleRef} id="cache-settings">
            <ButtonWithRole disabledFor={CONTENT_WRITE_REFUSED_ROLES} type="primary">
              Cache Expiration
            </ButtonWithRole>
          </div>
        </Tooltip>
      </Dropdown>
    </>
  );
}

export default CacheExpirationDropdownLegacy;
